import FormComponent from "./FormComponent";
import { allApis } from "../../../../request/config";
import {
  algorithmInput,
  allModules,
  cluster_types,
  descriptionInput,
  goalDateTypes,
  ImageUpload,
  internalRemarkInput,
  languages,
  structureProps,
  weightageInput,
} from "../../../../store/slices/constants/staticContents";
import { inputProp, ObjectValues } from "../../../login";
import apiRequest from "../../../../request/apiRequest/apiRequest";
import { convertFirstUpper } from "../../../../Regex";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Box, CircularProgress } from "@mui/material";

interface AllFormsProps {
  getGoalId: string;
  selectedExam: any;
  onClose: () => void;
  onSubmit: () => void;
  dockedCard: any;
}

const AllForms: React.FC<AllFormsProps> = ({
  getGoalId,
  selectedExam,
  onClose,
  onSubmit,
  dockedCard,
}) => {
  console.log(selectedExam,"selectedExam")
  const [loading, setLoading] = useState(true);
  const [allStepForm, setAllStepForm] = useState<any[]>([]);
  const [inputFormArray, setInputFormArray] = useState<any[]>([]);
const ModuleDetails = {
  [allModules[0]]: {
    apiCall: false,
    isTab: true,
    success: (row: ObjectValues | undefined, res: ObjectValues) => {
      return row
        ? `${row.name} exam has been successfully updated. Once the corresponding Executive approves the changes in exam, it will be available.`
        : `${res.name} exam has been successfully created. Once the corresponding Executive approves the exam, it will be visible.`;
    },
    formatList: (list: ObjectValues[]) => {
      return list && list.length > 0
        ? list.map((item: ObjectValues) => {
            return {
              ...item,
            };
          })
        : [];
    },
    filterValue: [
      { name: "name", operator: "startsWith", type: "string", value: "" },
      { name: "primary_language", operator: "eq", type: "select", value: null },
    ],
    inputSteps: () => {
      return [];
    },
    inputArray: (content: any) => {
      const row: any = content.selected_row;
      return [
        {
          label: "Exam Name",
          placeholder: "Enter Exam Name",
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "name",
        },
        {
          label: "Primary Language",
          placeholder: "Select Primary Language of Exam",
          value: undefined,
          list: languages.map((it: string) => {
            return {
              label: convertFirstUpper(it),
              id: it,
              value: convertFirstUpper(it),
            };
          }),
          defaultValue: {
            value: row?.primary_language
              ? convertFirstUpper(row?.primary_language)
              : "",
            id: row?.primary_language,
          },
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "autocomplete",
          listLabel: "label",
          api: "primary_language",
          // freeSolo:true
        },
        descriptionInput(),
        internalRemarkInput(),
      ] as inputProp[];
    },
  },
  [allModules[1]]: {
    apiCall: false,
    isTab: true,
    arrange_path: true,
    filterValue: [
      { name: "name", operator: "startsWith", type: "string", value: "" },
      { name: "path_order", operator: "eq", type: "number", value: null },
      { name: "registered_users", operator: "eq", type: "number", value: null },
      { name: "goal_type", operator: "eq", type: "select", value: null },
    ],
    success: (row: ObjectValues | undefined, res: ObjectValues) => {
      return row
        ? `${res.name} has been successfully updated. Once the corresponding Executive approves the changes in goal, it will be visible.`
        : `${res.name} has been successfully created. Once the corresponding Executive approves the goal, it will be visible.`;
    },
    formatList: (list: ObjectValues[]) => {
      return list && list.length > 0
        ? list.map((item: ObjectValues) => {
            return {
              ...item,
              goal_type: item.publish_date
                ? "announced"
                : item.tentative_publish_date
                ? "tentative"
                : "",
            };
          })
        : [];
    },
    inputSteps: () => {
      return [];
    },
    inputArray: (content: any, listView: structureProps) => {
      const row: any = content.selected_row;
      return [
        {
          label: "Goal Name",
          placeholder: "Enter Goal Name",
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "name",
        },
        {
          label: "Goal Date",
          placeholder: "Enter Goal Name",
          defaultValue: {
            value: row?.publish_date ?? row?.tentative_publish_date ?? "",
          },
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "date",
          api: "date",
        },
        {
          label: "Parent Exam",
          // disabled:true,
          pinned: true,
          defaultValue: {
            value: listView?.selected_row?.name ?? "",
            id: listView?.selected_row?.id ?? "",
          },
          value: {
            value: listView?.selected_row?.name ?? "",
            id: listView?.selected_row?.id ?? "",
          },
          list: listView?.list ?? [],

          listLabel: listView?.selected_row_field ?? "name",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "select",
          disabled: true,
          api: "exam",
        },
        // pathOrderInput(),
        {
          label: "Date Type",
          placeholder: "Select Date type",
          value: undefined,
          defaultValue: {
            
            value: row?.publish_date
              ? "Announced"
              : row?.tentative_publish_date
              ? "Tentative"
              : "",
            id: row?.publish_date
              ? "announced"
              : row?.tentative_publish_date
              ? "tentative"
              : "",
          },

          list: goalDateTypes.map((it: string) => {
            return {
              label: convertFirstUpper(it),
              id: it,
              value: convertFirstUpper(it),
            };
          }),
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "autocomplete",
          listLabel: "label",
          api: "date_type",
          // freeSolo:true
        },
        { fieldType: "extra" },
        { fieldType: "extra" },
        descriptionInput(),
        internalRemarkInput(),
      ] as inputProp[];
    },

    formatPayload: (data: ObjectValues) => {
      const newObj = {
        name: data.name,
        internal_remark: data.internal_remark,
        status: data.status,
        // path_order: 11,
        // "notification_date": "2024-01-1",
        // "tentative_notification_date": data.date_type==="tentative"?data.date:null,

        description: data.description,
        // "minimum_depth": 2147483647,
        // "maximum_depth": 2147483647,
        // "quiz_available_from_level": 2147483647,
        is_active: true,
        exam: data.exam,
        tag: [],
        [data.date_type === "announced"
          ? "publish_date"
          : "tentative_publish_date"]: data.date,
      };
      return newObj;
    },
  },
  [allModules[2]]: {
    apiCall: false,
    isTab: false,
    arrange_path: true,
    filterValue: [
      { name: "name", operator: "startsWith", type: "string", value: "" },
    ],

    success: (row: ObjectValues | undefined, res: ObjectValues) => {
      return row
        ? `New Section has been successfully created`
        : `Section has been updated created`;
    },
    formatList: (list: ObjectValues[]) => {
      return list && list.length > 0
        ? list.map((item: ObjectValues) => {
            return {
              ...item,
            };
          })
        : [];
    },
    formatPayload: (data: ObjectValues,  edit: any) => {
      const newObj: any = {
        // name: data.name,
        internal_remark: data.internal_remark,
        // path_order: 11,
        description: data.description,
        is_active: true,
        goal: data.goal,
        parent: null,
        logo_url: JSON.stringify(data.logo_url),
        weightage: data.weightage,
      };
      if (edit) {
        if (edit.name !== data.name) {
          newObj.name = data.name;
        }
      } else {
        newObj.name = data.name;
      }
      return newObj;
    },
    inputSteps: () => {
      return [];
    },
    inputArray: (content: any, listView: structureProps) => {
      const row: any = content.selected_row;
      return [
        {
          label: "Section Name",
          placeholder: "Enter Section Name",
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "name",
        },
        {
          label: "Parent Goal",
          // disabled:true,
          pinned: true,
          defaultValue: {
            value:listView?.selected_row?.name ?? "",
            id:  listView?.selected_row?.id ?? "",
          },
          value: "",
          list: listView?.list ?? [],

          listLabel: listView?.selected_row_field ?? "name",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "select",
          disabled: true,
          api: "goal",
        },
        // pathOrderInput(),
        weightageInput(),

        // logoInput(),
        descriptionInput(),
        internalRemarkInput(),
      ] as inputProp[];
    },
  },
  [allModules[3]]: {
    apiCall: false,
    arrange_path: true,
    filterValue: [
      { name: "name", operator: "startsWith", type: "string", value: "" },
    ],
    isTab: false,
    success: (row: ObjectValues | undefined, res: ObjectValues) => {
      return row
        ? `New Unit has been successfully created`
        : `Unit has been updated created`;
    },
    formatList: (list: ObjectValues[]) => {
      return list && list.length > 0
        ? list.map((item: ObjectValues) => {
            return {
              ...item,
            };
          })
        : [];
    },
    formatPayload: (data: ObjectValues,  edit: any) => {
      const newObj: any = {
        // name: data.name,
        internal_remark: data.internal_remark,
        // path_order: 11,
        description: data.description,
        is_active: true,
        goal: data.goal,
        parent: data.parent,
        logo_url: JSON.stringify(data.logo_url),
        weightage: data.weightage,
      };
      if (edit) {
        if (edit.name !== data.name) {
          newObj.name = data.name;
        }
      } else {
        newObj.name = data.name;
      }
      return newObj;
    },
    inputSteps: () => {
      return [];
    },
    inputArray: (content: any, listView: structureProps) => {
      const row: any = content.selected_row;
      return [
        {
          label: "Unit Name",
          placeholder: "Enter Unit Name",
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "name",
        },
        // pathOrderInput(),

        {
          label: "Parent Section",
          pinned: true,
          defaultValue: {
            value: listView?.selected_row?.name ?? "",
            id:  listView?.selected_row?.id ?? "",
          },
          value: "",
          list: listView?.list ?? [],

          listLabel: listView?.selected_row_field ?? "name",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "select",
          disabled: true,
          api: "parent",
        },

        weightageInput(),

        // logoInput(),
        //  { fieldType: "extra" }, { fieldType: "extra" },
        descriptionInput(),
        internalRemarkInput(),
      ] as inputProp[];
    },
  },
  [allModules[4]]: {
    apiCall: false,
    arrange_path: true,
    filterValue: [
      { name: "name", operator: "startsWith", type: "string", value: "" },
    ],
    isTab: false,
    success: (row: ObjectValues | undefined, res: ObjectValues) => {
      return row
        ? `New Topic has been successfully created`
        : `Topic has been updated created`;
    },
    formatList: (list: ObjectValues[]) => {
      return list && list.length > 0
        ? list.map((item: ObjectValues) => {
            return {
              ...item,
            };
          })
        : [];
    },
    formatPayload: (data: ObjectValues, edit: any) => {
      const newObj: any = {
        // name: data.name,
        internal_remark: data.internal_remark,
        // path_order: 11,
        description: data.description,
        is_active: true,
        algorithm: data.algorithm,
        goal: data.goal,
        parent: data.parent,
        logo_url: JSON.stringify(data.logo_url),
        weightage: data.weightage,
      };
      if (edit) {
        if (edit.name !== data.name) {
          newObj.name = data.name;
        }
      } else {
        newObj.name = data.name;
      }
      return newObj;
    },
    inputSteps: () => {
      return [];
    },
    inputArray: (content: any, listView: structureProps) => {
      const row: any = content.selected_row;
      return [
        {
          label: "Topic Name",
          placeholder: "Enter Topic Name",
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "name",
        },
        {
          label: "Parent Unit",
          pinned: true,
          defaultValue: {
            value:
              listView?.selected_row?.name ?? "",
            id:  listView?.selected_row?.id ?? "",
          },
          value: "",
          list: listView?.list ?? [],

          listLabel: listView?.selected_row_field ?? "name",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "select",
          disabled: true,
          api: "parent",
        },
        // pathOrderInput(),

        weightageInput(),
        algorithmInput(row),
        // logoInput()
        // ,
        // { fieldType: "extra" }, { fieldType: "extra" },
        descriptionInput(),
        internalRemarkInput(),
      ] as inputProp[];
    },
  },
  [allModules[5]]: {
    apiCall: false,
    arrange_path: true,
    filterValue: [
      { name: "name", operator: "startsWith", type: "string", value: "" },
    ],
    success: (row: ObjectValues | undefined, res: ObjectValues) => {
      return row
        ? `New Subtopic has been successfully created`
        : `Subtopic has been updated created`;
    },
    isTab: false,
    formatList: (list: ObjectValues[]) => {
      return list && list.length > 0
        ? list.map((item: ObjectValues) => {
            return {
              ...item,
            };
          })
        : [];
    },
    formatPayload: (data: ObjectValues, edit: any) => {
      const newObj: any = {
        // name: data.name,
        internal_remark: data.internal_remark,
        // path_order: 11,
        description: data.description,
        is_active: true,
        goal: data.goal,
        parent: data.parent,
        logo_url: JSON.stringify(data.logo_url),
        weightage: data.weightage,
      };
      if (edit) {
        if (edit.name !== data.name) {
          newObj.name = data.name;
        }
      } else {
        newObj.name = data.name;
      }
      return newObj;
    },
    inputSteps: () => {
      return [];
    },
    inputArray: (content: any, listView: structureProps) => {
      const row: any = content.selected_row;
      return [
        {
          label: "Subtopic Name",
          placeholder: "Enter Subtopic Name",
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "name",
        },
        {
          label: "Parent Topic",
          pinned: true,
          defaultValue: {
            value:
             listView?.selected_row?.name ?? "",
            id:  listView?.selected_row?.id ?? "",
          },
          value: "",
          list: listView?.list ?? [],

          listLabel: listView?.selected_row_field ?? "name",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "select",
          disabled: true,
          api: "parent",
        },
        // pathOrderInput(),

        weightageInput(),
        // logoInput()

        //  { fieldType: "extra" }
        // , { fieldType: "extra" },
        descriptionInput(),
        internalRemarkInput(),
      ] as inputProp[];
    },
  },
  [allModules[6]]: {
    apiCall: false,
    // arrange_path: true,
    filterValue: [
      { name: "name", operator: "startsWith", type: "string", value: "" },
    ],
    success: (row: ObjectValues | undefined, res: ObjectValues) => {
      return row
        ? `${
            row.cluster?.name ?? res.cluster?.name ?? "Cluster"
          } has been successfully updated. Once the corresponding Executive approves the changes, it will be available.`
        : `Cluster has been successfully created. Once the corresponding Executive approves the cluster, it will be available.`;
    },
    isTab: true,
    formatList: (list: ObjectValues[]) => {
      return list && list.length > 0
        ? list.map((item: ObjectValues) => {
            return {
              ...item,
              name: item.cluster?.name ?? "",
            };
          })
        : [];
    },
    formatPayload: (data: ObjectValues,  edit: any) => {
      const newObj ={
              cluster: {
                id: edit?.id || data?.id || null,
                name: data.name,
                exposure_index: data.exposure_index,
                lod_index: data.lod_index,
                completed_once_target_value: data.completed_once_target_value,
                min_time: data.min_time?Number( data.min_time):"",
                max_time: data.max_time?Number( data.max_time):"",
                type:
                  cluster_types.find((s) => s.name === data.type)?.id ??
                  data.type,
                description: data.description,
              },
              is_selection_set: false,
              syllabus_tree_node: selectedExam?.selected_row?.id??"",
            };
      return newObj;
    },
    inputArray: (content: any, listView: structureProps) => {
      const row: any = content.selected_row;
      return [
        {
          not_send_id: true,
          label: "Cluster Name",
          placeholder: "Enter Cluster Name",
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          onUpdate: async (val: ObjectValues) => {
            if (content.fetchSingleClusterQuestions && val.id) {
              const res: any = await content.fetchSingleClusterQuestions(
                val.id
              );
              return {
                "Cluster Name": res.name,
                "Cluster NameId": res.id,
                "Exposure Index": res.exposure_index,
                // "Accuracy Index": res.accuracy_index,
                // "Retention Index": res.retention_index,
                "Lod Index": res.lod_index,
                "Completed once target": res.completed_once_target_value,
                "Minimum seconds": res.min_time,
                "Maximum seconds": res.max_time,
                TypeId: res.type,
                Type: cluster_types.find((s) => s.id === res.type)?.name ?? "",
                Description: "description",
                cluster_res: res,
              };
            } else {
              return {
                "Cluster Name": val.name,
                "Cluster NameId": val.id,
              };
            }
          },
          fieldType: "text",
          //   list: content.all_clusters ?? [],
          listLabel: "name",
          api: "name",
          freeSolo: true,
          defaultValue: {
            value: row?.name ?? "",
          },
        },
        {
          label: "Parent Subtopic",
          pinned: true,
          defaultValue: {
            value: listView?.selected_row?.name ?? "",
            id: listView?.selected_row?.id ?? "",
          },
          value: "",
          list: listView?.list ?? [],

          listLabel: listView?.selected_row_field ?? "name",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "select",
          disabled: true,
          api: "parent",
        },
        {
          label: "Exposure Index",
          not_required: true,
          placeholder: "Enter Exposure Index Number",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "exposure_index",
          dataType: "number",
          defaultValue: {
            value: row?.exposure_index ?? "",
          },
        },
        {
          label: "Lod Index",
          not_required: true,
          placeholder: "Enter Lod Index Number",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "lod_index",
          dataType: "number",
          defaultValue: {
            value: row?.lod_index ?? "",
          },
        },
        {
          label: "Completed once target",
          not_required: true,
          placeholder: "Enter Completed once target",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "completed_once_target_value",
          dataType: "number",
          defaultValue: {
            value: row?.completed_once_target_value ?? "",
          },
        },
        {
          label: "Minimum seconds",
          placeholder: "Enter Minimum seconds",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "min_time",
          dataType: "number",
          defaultValue: {
            value: row?.min_time ?? "",
          },
        },
        {
          label: "Maximum seconds",
          placeholder: "Enter Maximum seconds",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "text",
          api: "max_time",
          dataType: "number",
          defaultValue: {
            value: row?.max_time ?? "",
          },
        },
        {
          label: "Type",
          placeholder: "Selecttype",
          value: undefined,
          list: cluster_types.map((it) => {
            return {
              label: convertFirstUpper(it.name),
              id: it.id,
              value: convertFirstUpper(it.name),
            };
          }),
          defaultValue: {
            value:
              cluster_types.find((s) => s.id === row?.type)?.name ??
              "",
            id: row?.type ?? "",
          },
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "autocomplete",
          listLabel: "label",
          api: "type",
        },
        {
          label: "Description",
          placeholder: "Enter Your Description",
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          multiline: 5,
          fieldType: "text",
          api: "description",
          not_required: true,
          dataType: "text",
          defaultValue: {
            value: row?.description ?? "",
          },
        },
      ];
    },

    inputSteps: () => {
      return [];
    },
  },
  [allModules[7]]: {
    apiCall: false,
    // arrange_path: t
    filterValue: [
      { name: "name", operator: "startsWith", type: "string", value: "" },
    ],
    success: (row: ObjectValues | undefined, res: ObjectValues) => {
      return row
        ? `New Question has been successfully created. Once the corresponding Executive approves the Question, it will be available.`
        : `Question has been successfully updated. Once the corresponding Executive approves the changes in Question, it will be available.`;
    },
    isTab: true,
    formatList: (list: ObjectValues[]) => {
      return list && list.length > 0
        ? list.map((item: ObjectValues) => {
            return {
              ...item,
              name: item?.translation?.text ?? "",
            };
          })
        : [];
    },
    inputSteps: () => {
      return [];
    },
    formatPayload: (data: ObjectValues, que_id?: any) => {
      const newObj: any = {
        cluster: data.parent,
        text: data.question,
        tag: data.tag?.length > 0 ? data.tag.map((it: any) => it.id) : [],
        options: [
          {
            text: data.option1,
            is_correct: data.correct_answer === "Option A" ? true : false,
            media_urls: "",
          },
          {
            text: data.option2,
            is_correct: data.correct_answer === "Option B" ? true : false,

            media_urls: "",
          },
          {
            text: data.option3,
            is_correct: data.correct_answer === "Option C" ? true : false,
            media_urls: "",
          },
          {
            text: data.option4,
            is_correct: data.correct_answer === "Option D" ? true : false,
            media_urls: "",
          },
        ],
        explanation: {
          media_urls: "",
          text: data.explanation,
        },
        question: que_id ? que_id : null,
        language: data.primary_language,
        // default_language:data.primary_language,
        is_default_language: data.is_default_language ?? que_id ? false : true,
        media_urls: "",
      };
      if (newObj.is_default_language) {
        newObj.default_language = newObj.language;
      }

      return newObj;
    },
    inputArray: (content: any, listView: structureProps) => {
      const row: any = content.selected_row;
      return [
        ImageUpload(),
        {
          label: "Default Language",
          placeholder: "Select Default Language",
          value: undefined,
          error: false,
          helperText: " c",
          endAdornment: "",
          not_required: true,
          fieldType: "checkbox",
          api: "is_default_language",
        },

        {
          label: "Question Language",
          placeholder: "Select Question Language",
          value: undefined,
          list: languages.map((it: string) => {
            return {
              label: convertFirstUpper(it),
              id: it,
              value: convertFirstUpper(it),
            };
          }),
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "autocomplete",
          listLabel: "label",
          api: "primary_language",
          // freeSolo:true
        },
        {
          label: "Parent Cluster",
          pinned: true,
          defaultValue: {
            value:
              row && listView
                ? listView.list?.find((it) => it.cluster.id === row?.cluster)
                    ?.cluster?.name
                : listView?.selected_row?.cluster?.name ??
                  listView?.selected_row?.name ??
                  "",
            id: row
              ? row?.cluster
              : listView?.selected_row?.cluster?.id ??
                listView?.selected_row?.id ??
                "",
          },
          value: "",
          list:
            listView?.list && listView?.list.length > 0
              ? listView?.list.map((item: ObjectValues) => {
                  return {
                    ...item,
                    name: item?.cluster?.name ?? item?.name ?? "",
                    id: item?.cluster?.id ?? item?.id ?? "",
                  };
                })
              : [],

          listLabel: listView?.selected_row_field ?? "name",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "select",
          disabled: true,
          api: "parent",
        },
        {
          label: "Question",
          // grid:{xs:12,sx:{width:"100%"}},
          fullWidth: true,
          // not_required: true,
          placeholder: "Enter Question",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "cktextEditor",
          api: "question",

          // defaultValue: {
          //   // value: row?.cluster?.lod_index ?? "",
          // },
        },
        {
          label: "Option A",
          // not_required: true,
          placeholder: "Enter Option A",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "cktextEditor",
          dataType: "option",
          api: "option1",
        },
        {
          label: "Option B",
          // not_required: true,
          placeholder: "Enter Option B",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          dataType: "option",
          fieldType: "cktextEditor",
          api: "option2",

          // defaultValue: {
          //   // value: row?.cluster?.lod_index ?? "",
          // },
        },
        {
          label: "Option C",
          // not_required: true,
          placeholder: "Enter Option C",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          dataType: "option",
          fieldType: "cktextEditor",
          api: "option3",

          // defaultValue: {
          //   // value: row?.cluster?.lod_index ?? "",
          // },
        },
        {
          label: "Option D",
          // not_required: true,
          placeholder: "Enter Option D",

          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          dataType: "option",
          fieldType: "cktextEditor",
          api: "option4",

          // defaultValue: {
          //   // value: row?.cluster?.lod_index ?? "",
          // },
        },
        {
          label: "Explanation",
          // grid:{xs:12,sx:{width:"100%"}},
          fullWidth: true,
          // not_required: true,
          placeholder: "Enter Explanation",
          not_required: true,
          value: "",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "cktextEditor",
          api: "explanation",

          // defaultValue: {
          //   // value: row?.cluster?.lod_index ?? "",
          // },
        },
        {
          label: "Question Tags",
          // pinned: true,
          // defaultValue: {
          //   // value:
          //   //   row && listView
          //   //     ? listView.list?.find((it) => it.id === row?.parent)?.name
          //   //     : listView?.selected_row?.name ?? "",
          //   // id: row ? row?.parent : listView?.selected_row?.id ?? "",
          // },
          // value: [],
          list: content.tags_list ?? [],
          multiple: true,
          listLabel: "name",
          error: false,
          helperText: " c",
          endAdornment: "",
          fieldType: "autocomplete",
          not_required: true,
          freeSolo: {
            dialog: true,
          },
          // disabled: true,
          api: "tag",
        },
      ] as inputProp[];
    },
  },
};
  // --- 1️⃣ Fetch function, memoized for stable reference
  const fetchSingleClusterQuestions = useCallback(async (id: string) => {
    return apiRequest({
      api: allApis.cluster_questions(`${id}/`),
      method: "GET",
    });
  }, []);

  // --- 2️⃣ Fetch and compute forms dynamically when dependencies change
  useEffect(() => {
    const computeForms = async () => {
      try {
        setLoading(true);
        const moduleConfig = ModuleDetails[dockedCard.title];
        if (!moduleConfig) {
          setAllStepForm([]);
          setInputFormArray([]);
          return;
        }

        const inputs = moduleConfig.inputArray?.(
          {
            tags_list: [],
            ...dockedCard,
            selected_row: dockedCard.selected_row ?? null,
          },
          selectedExam
        );
        setInputFormArray(inputs || []);
      } catch (error) {
        console.error("Error building form:", error);
      } finally {
        setLoading(false);
      }
    };

    computeForms();
  }, [dockedCard, selectedExam, fetchSingleClusterQuestions]);

  // --- 3️⃣ Derive extra fields dynamically
  const extraFields = useMemo(() => {
    if (dockedCard.edit) return [];

    const moduleTitle = dockedCard.title;
    if (
      [allModules[2], allModules[3], allModules[4], allModules[5]].includes(
        moduleTitle
      )
    ) {
      return [{ label: "goal", value: getGoalId }];
    }

    return [
      { label: "status", value: "draft" },
      { label: "is_active", value: true },
    ];
  }, [dockedCard, getGoalId]);

  // --- 4️⃣ Build success message formatter
  const successMessage = useCallback(
    (res: any) => {
      const moduleConfig = ModuleDetails[dockedCard.title];
      if (!moduleConfig) return "";
      return moduleConfig.success(
        dockedCard.edit ? dockedCard.selected_row ?? {} : undefined,
        res
      );
    },
    [dockedCard]
  );

  // --- 5️⃣ Prepare form props
  const formProps = useMemo(
    () => ({
      successMessage,
      formatPayload: ModuleDetails[dockedCard.title]?.formatPayload,
      extraFields,
      inputSteps: [],
      defaultValues: dockedCard.edit
        ? undefined
        : {
            [`Parent ${
              allModules[1] === dockedCard.title
                ? "Exam"
                : allModules[2] === dockedCard.title
                ? "Goal"
                : allModules[3] === dockedCard.title
                ? "Section"
                : allModules[4] === dockedCard.title
                ? "Unit"
                : allModules[5] === dockedCard.title
                ? "Topic"
                : allModules[16] === dockedCard.title
                ? "Subtopic"
                : allModules[16] === dockedCard.title
                ? "Cluster"
                : ""
            }`]: selectedExam?.selected_row?.name ?? "",
            [`Parent ${
              allModules[1] === dockedCard.title
                ? "Exam"
                : allModules[2] === dockedCard.title
                ? "Goal"
                : allModules[3] === dockedCard.title
                ? "Section"
                : allModules[4] === dockedCard.title
                ? "Unit"
                : allModules[5] === dockedCard.title
                ? "Topic"
                : allModules[16] === dockedCard.title
                ? "Subtopic"
                : allModules[16] === dockedCard.title
                ? "Cluster"
                : ""
            }Id`]: selectedExam?.selected_row?.id ?? "",
          },
      inputFormArray,
      header: dockedCard.title,
      editData: dockedCard.edit ? dockedCard.selected_row ?? {} : undefined,
      api: {
        edit: dockedCard.edit
          ? allApis[dockedCard.title].edit(
              dockedCard.selected_row?.id ??
                dockedCard.selected_row?.cluster?.id ??
                ""
            )
          : null,
        edit_method: dockedCard.title === "clusters" ? "POST" : "PATCH",
        create: allApis[dockedCard.title].create,
        create2: allApis[dockedCard.title].create2,
      },
      onSubmit,
      onClear: onClose,
    }),
    [
      successMessage,
      extraFields,
      allStepForm,
      inputFormArray,
      dockedCard,
      onSubmit,
      onClose,
    ]
  );

  // --- 7️⃣ Loader until ready
  if (loading) {
    return (
      <Box
        display="flex"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          minHeight: "250px",
        }}
      >
        <CircularProgress size={32} thickness={4} />
      </Box>
    );
  }
  if (inputFormArray.length === 0 && allStepForm.length === 0) {
    return (
      <Box
        display="flex"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          minHeight: "250px",
        }}
      >
        <CircularProgress size={32} thickness={4} />
      </Box>
    );
  }
  // --- 8️⃣ Render FormComponent after everything is loaded
  return <FormComponent {...formProps} />;
};

export default AllForms;
